module.exports = __webpack_public_path__ + "img/11.481f2d6d.svg";